import React, { useEffect, useState } from 'react';
import { getAllPortfolios } from '../../common/portfolioStore';
import { getAllTemplates } from '../../common/templateStore';

function Intro() {
  const [portfolioCount, setPortfolioCount] = useState(null);
  const [templateCount, setTemplateCount] = useState(null);

  useEffect(() => {
    getAllPortfolios()
      .then((data) => setPortfolioCount(data.length))
      .catch(() => setPortfolioCount(0));

    getAllTemplates()
      .then((data) => setTemplateCount(data.length))
      .catch(() => setTemplateCount(0));
  }, []);

  return (
    <section className="intro section-padding">
      <div className="container">
        <div className="row lg-marg">
          <div className="col-lg-8 md-mb80">
            <div className="row lg-marg align-items-center">
              <div className="col-md-6">
                <div className="img1 sm-mb50">
                  <img src="/assets/imgs/arw2.png" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="text">
                  <h3 className="mb-30">
                    Dijital başarı için{' '}
                    <span className="fw-300">doğru</span>{' '}
                    <span className="fw-300">ortağınız.</span>
                  </h3>
                  <p>
                    Kanus Digital olarak işletmenizin dijital dönüşümüne
                    öncülük ediyoruz. Yaratıcı tasarım ve güçlü teknoloji ile
                    markanızı öne çıkarıyoruz.
                  </p>

                  <a href="/page-about" className="underline main-color mt-40">
                    <span className="text">
                      Hakkımızda <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div className="numbers mt-80">
              <div className="row lg-marg">
                <div className="col-md-4">
                  <div className="item bord-thin-top pt-30 d-flex align-items-end mt-20">
                    <div>
                      <h3 className="fw-300 mb-10">100%</h3>
                      <h6 className="p-color sub-title">
                        Müşteri Memnuniyeti
                      </h6>
                    </div>
                    <div className="ml-auto">
                      <div className="icon-img-40">
                        <img src="/assets/imgs/arw0.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="item bord-thin-top pt-30 d-flex align-items-end mt-20">
                    <div>
                      <h3 className="fw-300 mb-10">
                        {portfolioCount !== null ? `${portfolioCount}+` : '...'}
                      </h3>
                      <h6 className="p-color sub-title">Yayındaki Projeler</h6>
                    </div>
                    <div className="ml-auto">
                      <div className="icon-img-40">
                        <img src="/assets/imgs/arw0.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="item bord-thin-top pt-30 d-flex align-items-end mt-20">
                    <div>
                      <h3 className="fw-300 mb-10">
                        {templateCount !== null ? `${templateCount}+` : '...'}
                      </h3>
                      <h6 className="p-color sub-title">Toplam Şablon</h6>
                    </div>
                    <div className="ml-auto">
                      <div className="icon-img-40">
                        <img src="/assets/imgs/arw0.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="img-full fit-img">
              <img src="/assets/imgs/intro/ana-sayfa-mockup.png" alt="Kanus Digital Mockup" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;
